<template>
  <page>
    <v-container fluid grid-list-sm>
      <!-- Keep for further need or enhancement -->
      <!-- <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div> -->
      <message :messages="messages"></message>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field
                            v-model="filter.clseNo"
                            :label="label.clseNo"
                            :error-messages="errors.collect('filter.clseNo')"
                            data-vv-name="filter.clseNo"
                            :data-vv-as="label.clseNo"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="filter.clseTitle"
                            :label="label.clseTitle"
                            :error-messages="errors.collect('filter.clseTitle')"
                            data-vv-name="filter.clseTitle"
                            :data-vv-as="label.clseTitle"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mr-2" @click="doNew">
            New Clause
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{ 'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.clseNo }}</td>
                  <td class="text-xs-left">{{ row.item.clseTitle }}</td>
                  <td class="text-xs-left">{{ formatBoolean(row.item.isPremWar) }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      query
                      @query="doQuery(row.item)"
                      review
                      @review="doReview(row.item)"
                      remove
                      @remove="doPromptRemove(row.item)"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove"> Are you sure that you want to delete the selected Clause? {{ deleteClse }} </confirm>
      <v-flex xs12 class="mt-3">
        <message :messages="messages"></message>
      </v-flex>
      <v-layout row wrap>
        <v-flex xs12> </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'

// Keep for further need or enhancement
// import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Default Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'defText' }
        },
        {
          text: 'Document Heading Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'docHdgTxtList' }
        },
        {
          text: 'Document No. Format',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'docNoForm' }
        },
        {
          text: 'Seq No., Various',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'docNoSeq' }
        },
        {
          text: 'Standard Risk Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'stdRiskTxtList' }
        }
      ],
      headers: [
        { text: 'Clause No.', align: 'left', value: 'clseNo' },
        { text: 'Clause Title', align: 'left', value: 'clseTitle' },
        { text: 'Premium Warranty', align: 'left', value: 'isPremWar' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selectedClse: undefined,
      deleteClse: '',
      toogleArray: [false],
      label: {
        clseNo: 'Clause No.',
        clseTitle: 'Clause Title'
      },
      filter: {
        clseNo: null,
        clseTitle: null
      },
      items: [],
      totalItems: 0,
      loading: false,
      tranMode: null,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    clsemenu() {
      return this.$store.state.docFormatParam.menu
    },
    filteredItems() {
      return this.items.filter((item) => {
        return (
          !this.search ||
          item.clseNo.toLowerCase().includes(this.search.toLowerCase()) ||
          item.clseTitle.toLowerCase().includes(this.search.toLowerCase())
        )
      })
    }
  },
  methods: {
    async fetchData(options) {
      const apiURI = this.clsemenu.getClauseList
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let messageFilters = clone(this.filter)
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), messageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((clause) => {
                const convertList = {
                  clseNo: clause.clseNo,
                  clseTitle: clause.clseTitle,
                  isPremWar: clause.isPremWar
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    /* async fetchData(options) {
      const apiUrl = this.clsemenu.getClauseList
      if (apiUrl) {
        this.loading = true
        this.$http.get(apiUrl).then(result => {
          this.items = []
          const { data } = result.data
          if (data) {
            data.map(clse => {
              const convertList = {
                clseNo: clse.clseNo,
                clseTitle: clse.clseTitle,
                isPremWar: clse.isPremWar
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    },
    */
    doReview(data) {
      if (data) {
        this.$router.push({ name: 'reviewClause', params: { clseNo: data.clseNo, clseTitle: data.clseTitle, tranMode: 'Review' } })
      }
    },
    doNew() {
      this.$router.push({ name: 'reviewClause', params: { clseNo: 'new', clseTitle: '', tranMode: 'New' } })
    },
    doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        const apiURI = this.clsemenu.checkDeleteClause
        if (apiURI) {
          const expand = {
            clseNo: data.clseNo
          }
          this.$http
            .get(expandURI(apiURI, expand))
            .then((result) => {
              this.selectedClse = data
              this.promptRemove = true
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.fieldMessage(data)
                this.notify(data)
              }
            })
        }
      }
    },
    async doRemove() {
      if (this.selectedClse.clseNo) {
        const apiURI = this.clsemenu.deleteClause
        if (apiURI) {
          const expand = {
            clseNo: this.selectedClse.clseNo
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData(true)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doClearFilters() {
      this.filter.clseNo = null
      this.filter.clseTitle = null
      this.fetchData(false)
    },
    doFilters() {
      this.fetchData(false)
    },
    doQuery(data) {
      if (data) {
        this.$router.push({ name: 'reviewClause', params: { clseNo: data.clseNo, clseTitle: data.clseTitle, tranMode: 'Query' } })
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    pagination: function (value) {
      this.fetchData(false)
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData(true)
  },
  components: {
    // Keep for further need or enhancement
    // SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style lang="scss">
</style>
